module.exports = __webpack_public_path__ + "static/media/khaleej1.d308a58d.png";